import { Typography as MuiTypography, useTheme } from "@mui/material";
import type { TypographyProps } from "@mui/material/Typography";
import { Typography as FoodsTypography } from "@foodpilot/foods";
import type { ComponentAppearance } from "src/components/appearance";

// ReactNode because either `cell.getValue()` returns the type of the column
// Or `cell.renderedValue` returns a type `ReactNode`.
type GridValue = ReactNode;

type GridTextProps = {
    value: GridValue;
    defaultValue?: string;
    variant?: "default" | "themed";
    typographyVariant?: TypographyProps["variant"];
    color?: TypographyProps["color"];
    appearance?: ComponentAppearance;
};
export const GridText = (props: GridTextProps) => {
    const {
        value,
        defaultValue = "-",
        variant = "default",
        typographyVariant = "body",
        color,
        appearance = "legacy",
    } = props;
    const theme = useTheme();
    const isProductUxV2 = appearance === "product-v2";
    const Typography = isProductUxV2 ? FoodsTypography : MuiTypography;

    const isValueEmpty = value === undefined || value === "" || value === null;
    const valueToDisplay = isValueEmpty ? defaultValue : value;

    const title = typeof value === "string" ? value : undefined;
    return (
        <Typography
            variant={typographyVariant}
            component="p"
            title={title}
            sx={{
                color: color ?? (variant === "default" ? undefined : theme.palette.primary[600]),
            }}
        >
            {valueToDisplay}
        </Typography>
    );
};

type GridTextListProps = {
    value: string[] | undefined;
    defaultValue?: string;
    separator?: string;
    appearance?: ComponentAppearance;
};
export const GridTextList = (props: GridTextListProps) => {
    const { value, defaultValue = "-", separator = " ", appearance = "legacy" } = props;
    const isProductUxV2 = appearance === "product-v2";
    const Typography = isProductUxV2 ? FoodsTypography : MuiTypography;

    const valueToDisplay = value !== undefined && value.length > 0 ? value : defaultValue;
    if (Array.isArray(valueToDisplay)) {
        const valueToDisplayArray = valueToDisplay.join(separator);
        return (
            <Typography
                variant="body"
                sx={{
                    color: "#000",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                }}
            >
                {valueToDisplayArray}
            </Typography>
        );
    }

    return (
        <Typography variant="body" sx={{ color: "#000" }}>
            {valueToDisplay}
        </Typography>
    );
};
